import { Box, Modal } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const VirtualTravelGuardModal = React.memo(({ isOpen, onClose, data, index }) => {
  const navigate = useNavigate();
  const modalTop = 1 + index * 1 + "%";

  //console.log("Virtual Travel Guard Modal Data:", data);

  const displayUserName = data?.userName || data?.userNam || "Unknown";

  return (
    <Modal
      open={isOpen}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return;
        if (reason === "escapeKeyDown") return;
        onClose();
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pt: modalTop,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: 2,
          width: 600,
          maxWidth: "90%",
          p: 3,
          boxShadow: 24,
        }}
      >
        <div className="row">
          <h5 className="text-dark text-end pe-4" onClick={onClose} style={{ cursor: "pointer" }}>
            X
          </h5>

          <h5 className="text-center pt-0 text-danger" style={{ marginTop: -15 }}>
            Virtual Travel Guard - {displayUserName}
          </h5>

          <div className="col-7 ms-4 mt-4">
            <p className="fs-6">
              <span className="fw-bold">User Name:</span> {displayUserName} <br />
              {data?.userPhone && data.userPhone !== "N/A" && (
                <>
                  <span className="fw-bold">User Phone:</span> {data.userPhone} <br />
                </>
              )}
              <span className="fw-bold">Type:</span> {data?.Type || "Virtual Travel Guard"} <br />
              <span className="fw-bold">Partner Type:</span> {data?.PartenerType || "N/A"} <br />
              {data?.PartenerType && data.PartenerType.toLowerCase() !== "alone" && data.PartenerType !== "N/A" ? (
                <>
                  <span className="fw-bold">Partner Name:</span>{" "}
                  {`${data?.Name || ""}${data?.lastName ? ` ${data.lastName}` : ""}`.trim() || "--"}{" "}
                  <br />
                  <span className="fw-bold">Partner Phone Number:</span>{" "}
                  {data?.PhoneNumber || "N/A"} <br />
                </>
              ) : null}
              <span className="fw-bold">Arrival Date:</span> {data?.ArrivalDate || "N/A"} <br />
              <span className="fw-bold">Arrival Time:</span> {data?.ArrivalTime || "N/A"} <br />
              <span className="fw-bold">Trip Date:</span> {data?.TripDate || "N/A"} <br />
              <span className="fw-bold">Trip Time:</span> {data?.TripTime || "N/A"} <br />
              <span className="fw-bold">Trip Status:</span> {data?.Trip_Status || "Active"} <br />
              <span className="fw-bold">Vehicle Number:</span> {data?.VehicleNumber || "N/A"} <br />
              <span className="fw-bold">Current Location:</span> {data?.currentLocTxt || "---"} <br />
              <span className="fw-bold">Destination:</span>{" "}
              {Array.isArray(data?.destLocTxt) ? data.destLocTxt.join(", ") : data?.destLocTxt || "---"}{" "}
              <br />
            </p>
          </div>

          <div className="col mt-2">
            {(data?.WellBeingTripPic || data?.userImage) && (
              <img
                className="mt-3"
                alt="Trip"
                height={120}
                width={170}
                style={{ borderRadius: 10, objectFit: "cover" }}
                src={data?.WellBeingTripPic || data?.userImage}
              />
            )}

            <div className="row mt-3">
              <div className="col mt-1">
                <button
                  className="btn btn-warning btn-sm pe-2 ps-2"
                  onClick={() => {
                    navigate(`/VirtualTravelGuard`);
                    onClose();
                  }}
                >
                  Check
                </button>

                <button
                  className="btn btn-primary btn-sm ms-1"
                  onClick={() => {
                    if (data?.userId) {
                      navigate(`/UserProfile/${data.userId}`);
                    } else {
                      navigate(`/VirtualTravelGuard`);
                    }
                    onClose();
                  }}
                >
                  See Profile
                </button>
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
});

export default VirtualTravelGuardModal;
